import classNames from 'classnames'

import styles from '../ContactEditDialog.module.scss'

export const dropdownRenderFunction = (item: any) => (
  <>
    <i className={classNames(item.Class, styles.selectIcon)} style={{ color: item.Color }} />
    <span>{item.Hint}</span>
  </>
)
